export function calculateFeverLength(
  feverSection: number | undefined,
  sectionTimes: number[] | undefined,
  songDuration: number
): { startTime: number; endTime: number; lengthMs: number } | null {
  if (!feverSection || feverSection <= 0 || !sectionTimes) {
    return null;
  }

  // Convert 1-based index to 0-based
  const feverSectionIndex = feverSection - 1;

  // Fever sections are limited to sections 1-5 (0-4 in 0-based indexing)
  if (feverSectionIndex >= 5) {
    return null;
  }

  // Calculate start time (matching ChartRenderer logic)
  const startTime = feverSectionIndex === 0 ? 0 : sectionTimes[feverSectionIndex - 1];

  // Calculate end time (matching ChartRenderer logic)
  let endTime: number;
  if (feverSectionIndex === 4) {
    // If it's the 5th section (index 4), use song duration
    endTime = songDuration;
  } else if (feverSectionIndex >= sectionTimes.length) {
    // If beyond available sections, use song duration
    endTime = songDuration;
  } else {
    endTime = sectionTimes[feverSectionIndex];
  }

  const lengthMs = endTime - startTime;

  if (lengthMs <= 0) {
    return null;
  }

  return { startTime, endTime, lengthMs };
}

export function formatDuration(
  milliseconds: number,
  includeDecimals: boolean = true
): {
  formatted: string;
  totalSeconds: number;
  minutes: number;
  seconds: number;
} {
  const totalSeconds = milliseconds / 1000;
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = includeDecimals ? totalSeconds % 60 : Math.floor(totalSeconds % 60);

  const secondsStr = includeDecimals
    ? seconds.toFixed(2).padStart(5, '0')
    : seconds.toString().padStart(2, '0');

  return {
    formatted: `${minutes}:${secondsStr}`,
    totalSeconds,
    minutes,
    seconds
  };
}
